import { parsePhoneNumber } from './parsePhoneNumber';

/**
 * Eg: "+1 213 373 4253"
 */
export const formatInternationalPhoneNumber = (input: string) => {
	try {
		return parsePhoneNumber(input).format('INTERNATIONAL');
	} catch {
		return input;
	}
};
